<template>
	<div class="row">
		<div class="col-xl-3 col-md-6 mb-4">
			<bga2-info-card 
				:classe="{
					'border-left-success': dados.total_dia > 0,
					'border-left-danger': dados.total_dia < 0,
					'border-left-secondary': dados.total_dia == 0
				}">
		    	<div class="col mr-2">
					<div 
						class="text-xs font-weight-bold text-uppercase mb-1"
						:class="{
							'text-success': dados.total_dia > 0,
							'text-danger': dados.total_dia < 0,
							'text-secondary': dados.total_dia == 0
						}">
						Dia
					</div>
					<div class="h5 mb-0 font-weight-bold text-gray-800">	
						R$ {{ dados.total_dia_br }}
					</div>
				</div>
				<div class="col-auto">
					<i class="fas fa-dollar-sign fa-2x text-gray-300"></i>
				</div>
		    </bga2-info-card>
		</div>
		<div class="col-xl-3 col-md-6 mb-4">
			<bga2-info-card 
				:classe="{
					'border-left-success': dados.total_semana > 0,
					'border-left-danger': dados.total_semana < 0,
					'border-left-secondary': dados.total_semana == 0
				}">
		    	<div class="col mr-2">
					<div 
						class="text-xs font-weight-bold text-uppercase mb-1"
						:class="{
							'text-success': dados.total_semana > 0,
							'text-danger': dados.total_semana < 0,
							'text-secondary': dados.total_semana == 0
						}">
						Semana
					</div>
					<div class="h5 mb-0 font-weight-bold text-gray-800">	
						R$ {{ dados.total_semana_br }}
					</div>
				</div>
				<div class="col-auto">
					<i class="fas fa-dollar-sign fa-2x text-gray-300"></i>
				</div>
		    </bga2-info-card>
		</div>
		<div class="col-xl-3 col-md-6 mb-4">
			<bga2-info-card 
				:classe="{
					'border-left-success': dados.total_mes > 0,
					'border-left-danger': dados.total_mes < 0,
					'border-left-secondary': dados.total_mes == 0
				}">
		    	<div class="col mr-2">
					<div 
						class="text-xs font-weight-bold text-uppercase mb-1"
						:class="{
							'text-success': dados.total_mes > 0,
							'text-danger': dados.total_mes < 0,
							'text-secondary': dados.total_mes == 0
						}">
						Mês
					</div>
					<div class="h5 mb-0 font-weight-bold text-gray-800">	
						R$ {{ dados.total_mes_br }}
					</div>
				</div>
				<div class="col-auto">
					<i class="fas fa-dollar-sign fa-2x text-gray-300"></i>
				</div>
		    </bga2-info-card>
		</div>
		<div class="col-xl-3 col-md-6 mb-4">
		    <bga2-info-card 
		    	:classe="{
					'border-left-success': dados.total_ano > 0,
					'border-left-danger': dados.total_ano < 0,
					'border-left-secondary': dados.total_ano == 0
				}">
		    	<div class="col mr-2">
					<div 
						class="text-xs font-weight-bold text-uppercase mb-1"
						:class="{
							'text-success': dados.total_ano > 0,
							'text-danger': dados.total_ano < 0,
							'text-secondary': dados.total_ano == 0
						}">
						Ano
					</div>
					<div class="h5 mb-0 font-weight-bold text-gray-800">	
						R$ {{ dados.total_ano_br }}
					</div>
				</div>
				<div class="col-auto">
					<i class="fas fa-dollar-sign fa-2x text-gray-300"></i>
				</div>
		    </bga2-info-card>
		</div>
	</div>
</template>

<script>
	export default {
		props: ['date'],
		data(){
			return {
				dados: []
			}
		},
		created(){
			this.getDados();
		},
		methods: {
			getDados(){
				axios.get(this.$url+'/api/adm/financeiro/data?data='+this.date)
	            .then(response => {
	            	this.dados = response.data;
	            })
	            .catch(error => {
	            	console.log(error)
	            });
			},
		},
		watch: {
			date(){
				if(this.date){
					this.getDados()
				}
			}
		}
	}
</script>